import { render, staticRenderFns } from "./importComments.vue?vue&type=template&id=2f1a5caa&scoped=true&"
import script from "./importComments.vue?vue&type=script&lang=js&"
export * from "./importComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1a5caa",
  null
  
)

export default component.exports